import React from "react";
import { Page } from "components/common";
import { compose, withState, withPropsOnChange } from "recompose";
import { Alert } from "reactstrap";
import { get } from "lodash";
import { Link } from "react-router-dom";

export const Register = ({
  success,
  failure,
}) => (
  <Page>
    {success !== null ? (success ? (
      <Alert color="success" className="text-center">
        <span className="fa fa-check mr-1" />
        Your account has been successfully verified, you can now{" "}
        <Link to="/login" replace>
          login
        </Link>
      </Alert>
    ) : (
      <Alert color="warning" className="text-center">
        Failed
      </Alert>
    )) : (
      <Alert color="warning" className="text-center">
        Verifying...
      </Alert>
  
    )}
  </Page>
);

const enhance = compose(
  withState("success", "setSuccess", null),
  withState("failure", "setFailure", null),
  withPropsOnChange([], ({ client, match, history, setSuccess, setFailure }) => {
    client
      .post("/verify_email", {
        token: match.params.token,
      })
      .then((response) => {
        setSuccess(true)

        if (response && response.data && response.data.redirect) {
          if (response.data.connected_organisation_id) {
            // This is a quick (but no recommended at all) solution to select the organisation on Verify Email page.
            localStorage.setItem('hesaab/organisationId', response.data.connected_organisation_id)
          }
          setTimeout(() => {
            if (response.data.subscription_plan_id) {
              window.location.href = `/subscription-summary/${response.data.subscription_plan_id}`
            } else {
              window.location.href = '/'
            }
          }, 1000)
        }
      })
      .catch((err) => {
        const code = get(err, "response.data.code");
        if (code === "InvalidToken") {
          setFailure(
            "This link is not valid, please check the email and try again"
          );
        } else if (code === "AlreadyVerified") {
          setSuccess(true);
        } else {
          throw err;
        }
      });
  })
);

export default enhance(Register);
